//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectFace.js";
import "../no/SelectObject.js";
let d=[[[0,"BlankNumber",1,0],[0,"BlankPart",1,"TaggedObject",0],[0,"CreateBlankOption",1,0],[0,"CreatedByInsert",1,0],[1,"DatumFace",0,"SelectFace",0],[0,"DisplayPartImport",1,"TaggedObject",0],[0,"DisplayPartSelect",1,"TaggedObject",0],[0,"EditBlankOption",1,0],[0,"InsertNewBlank",1,"TaggedObject",0],[0,"SheetMetalPartName",1,0],[1,"StationaryFace",0,"SelectFace",0],[0,"Type",1,0],[0,"WorkPart",1,"TaggedObject",0]],[[[],"ImportBlank",{},0,0],[["blankFullName"],"ImportBlankPart",{R_:{blankTag:"NXObject"}},1,0],[[],"SelectBlank",{},0,0],[[],"UnformSheet",{},0,0],[[],"UpdateBlank",{},0,0],[["blankFullName"],"UpdateBlankPart",{R_:{blankPart:"NXObject"}},1,0],[[],"RemoveBlank",{},0,0]],[]];
SPLM.Tooling.BlankGeneratorBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.BlankGeneratorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.BlankGeneratorBuilder.Types = Object.freeze({
    "CreateBlank" : "CreateBlank", "EditBlank" : "EditBlank"});

SPLM.Tooling.BlankGeneratorBuilder.EditBlankType = Object.freeze({
    "Update" : "Update", "Remove" : "Remove"});

SPLM.Tooling.BlankGeneratorBuilder.CreateBlankType = Object.freeze({
    "Import" : "Import", "Select" : "Select", "Unform" : "Unform"});

export default SPLM;